import React, { useRef, useState } from "react";
import styled from "styled-components";

import GrayTrashIcon from '../../../Image/GrayTrashIcon.png';
import RedTrashIcon from '../../../Image/RedTrashIcon.png';

export default function WodTitleBox(props) {
  const { 
    data, 
    wodsLength,
    onClickDeleteWodButton,
    onClickUpWodButton,
    onClickDownWodButton,
    onClickWod
  } = props;

  const [isHoverIndexUp, setIsHoverIndexUp] = useState(false);
  const [isHoverIndexDown, setIsHoverIndexDown] = useState(false);
  const [isHoverTitle, setIsHoverTitle] = useState(false);
  const [isHoverDeleteButton, setIsHoverDeleteButton] = useState(false);
  
  const DeleteRef = useRef(null);

  // 글자 색상 결정 //
  function decideFontColor() {
    if (isHoverDeleteButton) return '#FF0000';
    else if (isHoverTitle) return '#FF8B48';
    else return '#FFFFFF';  
  }

  // 와드 컴포넌트 클릭시 //
  function onClickWodBox(e) {
    if (DeleteRef.current.contains(e.target)) return;
    
    onClickWod(data);
  }

  return (
    <WodBoxWrapper>
      <IndexChangeButtonWrapper>
        <IndexButtonWrapper 
          isUpButton={true}
          onMouseOver={() => setIsHoverIndexUp(true)}
          onMouseLeave={() => setIsHoverIndexUp(false)}
          onClick={() => onClickUpWodButton(data)}>
          <IndexUpButton isHover={isHoverIndexUp}/>
        </IndexButtonWrapper>
        <IndexButtonWrapper 
          isUpButton={false}
          onMouseOver={() => setIsHoverIndexDown(true)}
          onMouseLeave={() => setIsHoverIndexDown(false)}
          onClick={() => onClickDownWodButton(data, wodsLength)}>
          <IndexDownButton isHover={isHoverIndexDown}/>
        </IndexButtonWrapper>
      </IndexChangeButtonWrapper>
      <WodInfoBox
        onMouseOver={() => setIsHoverTitle(true)}
        onMouseLeave={() => setIsHoverTitle(false)}
        onClick={onClickWodBox}>
        <WodTitleWrapper>
          {/* <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={decideFontColor()} hover='pointer'>{'Event ' + data.viewIndex}</Text> */}
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={decideFontColor()} hover='pointer'>{data.wodSubTitle}</Text>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={decideFontColor()} hover='pointer'>{data.wodTitle}</Text>
        </WodTitleWrapper>
        <DeleteButton
          ref={DeleteRef}
          onMouseOver={() => setIsHoverDeleteButton(true)}
          onMouseLeave={() => setIsHoverDeleteButton(false)}
          onClick={() => onClickDeleteWodButton(data)}>
          <Icon opacity={isHoverDeleteButton ? 1 : 0} src={RedTrashIcon}/>
          <Icon isHover={isHoverDeleteButton ? 0 : 1} src={GrayTrashIcon}/>
        </DeleteButton>
      </WodInfoBox>
    </WodBoxWrapper>
  )
}

const WodBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;

  gap: 5px;
`;

const IndexChangeButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 16px;
  height: 40px;

  // gap: 0px;
`;

const IndexButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 14px;
  height: 20px;

  :hover {
    cursor: pointer;
  }
`;

const IndexUpButton = styled.div`
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 5px solid ${props => props.isHover ? `#FFFFFF` : `#8B8B8D`};

  :hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const IndexDownButton = styled.div`
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 5px solid ${props => props.isHover ? `#FFFFFF` : `#8B8B8D`};

  :hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const WodInfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 8px 10px;

  width: calc(100% - 30px);
  height: 24px;

  border-radius: 10px;
  background-color: #2F2F32;

  :hover {
    cursor: pointer;
  }
`;

const WodTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: calc(100% - 34px);
  max-width: calc(100% - 34px);
  height: 100%;

  overflow: hidden;

  gap: 10px;
`;

const DeleteButton = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;

  :hover {
    cursor: pointer;
  }
`;

const Icon = styled.img`
  position: absolute;

  width: 18px;
  height: 20px;

  opacity: ${props => props.opacity};

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  
  :hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;